import React from 'react';
import ReactApexCharts from 'react-apexcharts';
import PropTypes from 'prop-types';

function LineChartSeries({ labels, series, colors }) {
  const options = {
    stroke: {
      curve: 'smooth',
    },
    xaxis: {
      categories: labels,
    },
    tooltip: {
      x: {
        format: 'dd/MM/yy HH:mm',
      },
    },
    chart: {
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    colors,
  };

  return (
    <ReactApexCharts
      height="100%"
      options={options}
      series={series}
      type="area"
    />
  );
}
LineChartSeries.defaultProps = {
  labels: [],
  series: [],
  colors: [],
};

LineChartSeries.propTypes = {
  labels: PropTypes.instanceOf(Array),
  series: PropTypes.instanceOf(Array),
  colors: PropTypes.instanceOf(Array),
};

export default LineChartSeries;
